/**
 * Фиксированные кости режима обучения.
 *
 * Сценарии глав рассчитаны на конкретные исходы боев (тексты модалок называют
 * результаты заранее), поэтому в обучении генератор костей урона подменяется
 * очередью значений из конфига. Очередь пополняется шагами сценария и
 * операциями скрипта бота (поле dice.damage) РОВНО перед событием, которое
 * эти кости потребит, — так порядок потребления остается управляемым.
 *
 * Значения очереди — уже ГРАНИ кости урона (-3..0), а не броски d6.
 * Хук потребления — в getDamageDiceRoll (см. src/utils/dice/getDamageDiceRoll.js).
 * Включение и выключение на время главы — useTutorialDiceSession.
 */

let isTutorialDiceActive = false;
let damageDiceQueue = [];

/**
 * Выключение очередь НЕ очищает: эффект партии глушит кости и тогда, когда
 * партия продолжается (Fast Refresh в разработке), и включает их обратно —
 * заготовленные шагом кости должны дожить до своего события. Новая глава
 * начинает с чистой очереди через resetTutorialDice
 */
export const setTutorialDiceActive = (isActive) => {
  isTutorialDiceActive = Boolean(isActive);
};

export const resetTutorialDice = () => {
  isTutorialDiceActive = false;
  damageDiceQueue = [];
};

export const enqueueTutorialDamageDice = (values) => {
  if (!Array.isArray(values) || values.length === 0) {
    return;
  }
  damageDiceQueue.push(...values);
};

/**
 * Следующее фиксированное значение кости урона или null, если обучение
 * неактивно/очередь пуста (тогда бросок честный — страховка от рассинхрона
 * сценария: лучше случайная кость, чем упавший расчет боя)
 */
export const takeTutorialDamageDice = () => {
  if (!isTutorialDiceActive || damageDiceQueue.length === 0) {
    return null;
  }
  return damageDiceQueue.shift();
};
